<template>
    <div class="atom-toggle">
        <transition name="fade" mode="out-in">
            <div :key="active" class="slot-wrapper">
                <slot v-if="active === 'first'" name="first" />
                <slot v-else name="second" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'AtomToggle',
    props: {
        active: {
            type: String,
            default: 'first',
            validator: value => ['first', 'second'].includes(value),
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

.atom-toggle {
    min-height: 1em;
}

.slot-wrapper {
    display: flex;
    gap: 10px;
}
</style>